export default {
    methods: {
        showMobileAppRequirementError() {
            this._message(
                "Client mobile app add-on is enabled. Please insert either the client's email address OR mobile phone number to proceed.",
                "danger",
                -1,
                null,
                null,
                "Email address or mobile number is required"
            );
        }
    }
};
